import React, { useState } from 'react';
import { sendToTelegram } from '../../services/telegramService';
import './ContactForm.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        requirement: 'flat'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await sendToTelegram(formData);
            setFormData({ name: '', email: '', phone: '' });
            alert('Thank you! We will contact you soon.');
        } catch (error) {
            alert('Sorry, there was an error. Please try again later.');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="contact-form">
            <h2>Get in Touch</h2>
            <div className="input-group">
                <label>Name</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your name"
                />
            </div>
            <div className="input-group">
                <label>Email</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                />
            </div>
            <div className="input-group">
                <label>Phone</label>
                <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+91 XXXXX XXXXX"
                />
            </div>
            <div className="input-group">
                <label>Requirement</label>
                <select
                    name="requirement"
                    value={formData.requirement}
                    onChange={handleChange}
                    required
                >
                    <option value="flat">Flat</option>
                    <option value="villa">Villa</option>
                </select>
            </div>
            <button type="submit" className="submit-button">Send Message</button>
        </form>
    );
};

export default ContactForm;